import { Box } from '@mui/material'
import { LatLngExpression } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { MapContainer, Marker, TileLayer } from 'react-leaflet'

type Props = {
  latitude?: number | null
  longitude?: number | null
}

export const DeviationMap = ({ latitude, longitude }: Props) => {
  if (latitude == null || longitude == null || latitude === 0 || longitude === 0) return null
  const center: LatLngExpression = [latitude, longitude]
  return (
    <Box sx={{ height: 220, width: '100%', mt: 2, mb: 2 }}>
      <MapContainer center={center} zoom={14} style={{ height: '100%', width: '100%' }} zoomControl={false} scrollWheelZoom={false} attributionControl={false}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={center} />
      </MapContainer>
    </Box>
  )
}
